import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid, styled } from '@mui/material';
import { Header } from '../../components';
const Container = styled(Grid) `
  display: flex;
  width: 100%;
  flex-direction: column;
  flex: 1;
`;
const WithHeader = ({ children, ...headerProps }) => {
    const header = _jsx(Header, { ...headerProps });
    return (_jsxs(Container, { item: true, container: true, children: [header, children] }));
};
export default WithHeader;
//# sourceMappingURL=index.js.map